import { Route, Routes } from "react-router";

import { isInTeams } from "common/teams";
import WarnBrowser from "common/warnBrowser/WarnBrowser";
import Footer from "views/footer/Footer";
import Header from "views/header/Header";
import ActivateUser from "views/login/activateUser/containers/ActivateUser";
import InviteUser from "views/login/activateUser/containers/InviteUser";
import GenerateOnetimeLogin from "views/login/generateOnetimeLogin/containers/GenerateOnetimeLogin";
import AuthenticateInternalUser from "views/login/login/containers/AuthenticateInternalUser";
import OnetimeLogin from "views/login/onetimeLogin/containers/OnetimeLogin";
import ResetPassword from "views/login/resetPassword/containers/ResetPassword";
import SetPassword from "views/login/resetPassword/containers/SetPassword";
import TeamsLogin, { TeamsLoginPopup } from "views/login/teamsLogin/TeamsLogin";
import Login from "views/login/login/containers/Login";

import "./Layout.scss";

export default function LoginLayout() {
  return (
    <div className="layoutWrapper">
      <WarnBrowser />
      <Header />
      <div className="mainWrapper">
        <div className="contentWrapper">
          <Routes>
            <Route
              path="/authenticate-internal-user"
              element={<AuthenticateInternalUser />}
            />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/activateuser/:key" element={<ActivateUser />} />
            <Route path="/setpassword/:key" element={<SetPassword />} />
            <Route
              path="/login"
              element={isInTeams() ? <TeamsLogin /> : <Login />}
            />
            <Route path="/onetime-login" element={<OnetimeLogin />} />
            <Route
              path="/generate-onetime-login"
              element={<GenerateOnetimeLogin />}
            />
            <Route path="/inviteuser/:key" element={<InviteUser />} />
            <Route path="/teams-login-popup" element={<TeamsLoginPopup />} />
            <Route path="/*" element={<Login />} />
          </Routes>
        </div>
      </div>
      <Footer />
    </div>
  );
}
